import api from './api';
import { SystemConfig, SystemConfigFormData, ApiResponse } from '../types';

const SYSTEM_ID = process.env.REACT_APP_SYSTEM_ID || '3';

export const systemConfigService = {
  async get(): Promise<SystemConfig> {
    const response = await api.get<ApiResponse<SystemConfig>>('/system-config', {
      params: { system_id: SYSTEM_ID }
    });
    return response.data.data!;
  },

  async update(data: SystemConfigFormData): Promise<SystemConfig> {
    const formData = new FormData();

    // Adicionar system_id
    formData.append('system_id', SYSTEM_ID);

    Object.entries(data).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        if (key === 'logo' && value instanceof File) {
          formData.append(key, value);
        } else if (typeof value === 'boolean') {
          formData.append(key, value ? '1' : '0');
        } else {
          formData.append(key, value.toString());
        }
      }
    });

    const response = await api.post<ApiResponse<SystemConfig>>(
      '/system-config',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data.data!;
  },

  async uploadLogo(file: File): Promise<string> {
    const formData = new FormData();
    formData.append('system_id', SYSTEM_ID);
    formData.append('logo', file);

    const response = await api.post<ApiResponse<{ url: string }>>(
      '/system-config/logo',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data.data!.url;
  },
};
